module.exports = __webpack_public_path__ + "img/collection-weddingRingsSoleil@2x.4baf7f8.jpg";